import React from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const ExpensesReportsListItem = ({ item, formatter,index}) => {
  const { t } = useTranslation("global");
  const _taxTypeList = [
    {
      label: t("Vat.vat-15"),
      value: "VAT-15",
      lang: i18next.language,
    },
    {
      label: t("Vat.zero"),
      value: "ZERO",
      lang: i18next.language,
    },
    {
      label: t("Vat.exempt"),
      value: "EXEMPT",
      lang: i18next.language,
    },
  ];
  return (
    <div className="px-2 py-1 flex gap-2 justify-between items-center border-b border-[#ddd0bf] border-opacity-50 text-sm text-[#261759] bg-white hover:bg-[#F5F8F1] transition">
      <div className="w-4 text-start  text-[#261759]">{index+1}</div>
      <div className="w-24 text-center  text-[#261759]">{item?.code}</div>
      <div className="flex-1 text-start">
        {item?.desc ? `${item?.desc}` : t("Salaries.nonbondDescription")}
      </div>
      {/* <div  className='text-center  text-gray-600'>{item.inv_date.substring(0,10)}</div> */}
      <div className="w-32 text-center">{item.seller_name}</div>
      <div className="w-40 text-center text-[#261759]">
        {item?.expense_date}
      </div>
      <div className="w-32 text-center  text-[#261759]">
        {item?.total_amount_with_vat}
      </div>
      <div className="w-32 text-center text-[#261759]">
        {item?.details?.length > 0
          ? _taxTypeList.find((tax) => tax.value === item.details[0].tax_type)
              ?.label || "N/A"
          : "N/A"}
      </div>
    </div>
  );
};

export default ExpensesReportsListItem;
